import { render, staticRenderFns } from "./FeaturedAddDesign.vue?vue&type=template&id=a3a322fe&"
import script from "./FeaturedAddDesign.vue?vue&type=script&lang=js&"
export * from "./FeaturedAddDesign.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedAddDesign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports